import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 25,
    },
    contentPrices: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 10
    },
    infoPrice: {
        fontSize: 14,
        fontWeight: 'bold'
    },
    contentInput: {
        marginBottom: 20
    },
    containerHeader: {
        backgroundColor: '#2C2C2E',
        height: 90,
        width: '100%',
        borderBottomColor: '#32BFB1',
        borderBottomWidth: 2
    },
    contentHeader: {
        paddingLeft: 25,
        marginTop: 40,
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginRight: 82
    },
    titleHeader: {
        color: '#fff',
        fontWeight: 'bold',
        textAlign: 'center',
        width: '100%',
        marginTop: 8
    }
});

export default styles;